import type { FrequencyPeriod } from 'api/recoveryAi.types'
import { buildTranslate } from 'locales'
import React from 'react'
import ConfigCard from 'scenes/RecoveryAI/components/ConfigCard'
import EscalationRulesBody, {
  EscalationRulesChange,
} from './EscalationRulesBody'

const t = buildTranslate('recovery_ai.wizard.limits')

export type { EscalationRulesChange }

type Props = {
  frequentThreshold: string
  frequencyPeriod: FrequencyPeriod
  repeatedThreshold: string
  // AI-302 (FR-41): OPTIONAL. When `autoResolutionThreshold` is provided (the
  // Settings pane), the suspected-gaming section renders; the wizard limits step
  // omits them, so it stays visually unchanged (no new required prop).
  autoResolutionThreshold?: string
  autoResolutionPeriod?: FrequencyPeriod
  onChange: (partial: EscalationRulesChange) => void
  // AI-64: when true, every control renders read-only (native disabled).
  // Optional so the wizard limits step stays editable unchanged; the Settings
  // pane passes `!canManage` so view-only operators get a read-only view.
  disabled?: boolean
}

// Presentational/controlled: holds no state and never fetches. Both the wizard
// limits step and the Agent-Tuning modal (EscalationRulesModalBody) render this
// — the ConfigCard chrome is what they both want. The Settings pane (AI-903)
// renders EscalationRulesBody directly under SettingsPaneChrome instead, since
// a second boxed card there duplicated the pane's own chrome.
const EscalationRulesCard = (props: Props) => (
  <ConfigCard
    title={t('escalation_rules')}
    subtitle={t('escalation_rules_desc')}
  >
    <EscalationRulesBody {...props} />
  </ConfigCard>
)

export default EscalationRulesCard
